<!-- Container-fluid starts-->
<div class="container-fluid">
  <div class="row">
    <!-- col-xl-3 xl-100 -->
    <div class="col-md-3 col-6">
      <div class="card">
          <div class="card-header bg-primary text-center">
              <h5>Today</h5>
          </div>
          <div class="card-body bg-primary">
            <table style="width:100%" >
              <tr>
                <td class="fa fa-caret-right txt-secondary" width="10%"></td>
                <td width="80%">Global revenue</td>
                <td width="10%">{{profToday?.globalRevenue | currency}}</td>
              </tr>
              <tr>
                <td class="fa fa-caret-right txt-secondary" width="10%"></td>
                <td width="80%">Global profit</td>
                <td width="10%">{{profToday?.globalProfit | currency}}</td>
              </tr>
              <tr>
                <td class="fa fa-caret-right txt-secondary" width="10%"></td>
                <td width="80%">Global Clicks</td>
                <td width="10%">{{profToday?.globalClicks}}</td>
              </tr>
              <tr>
                <td class="fa fa-caret-right txt-secondary" width="10%"></td>
                <td width="80%">Global Conversions</td>
                <td width="10%">{{profToday?.globalConversions}}</td>
              </tr>
            </table>
          </div>
      </div>
    </div>
    <div class="col-md-3 col-6">
      <div class="card">
          <div class="card-header bg-primary text-center">
              <h5>Yesterday</h5>
          </div>
          <div class="card-body bg-primary">
            <table style="width:100%">
              <tr>
                <td class="fa fa-caret-right txt-secondary" width="10%"></td>
                <td width="80%">Global revenue</td>
                <td width="10%">{{profYeste?.globalRevenue | currency}}</td>
              </tr>             <tr>
                <td class="fa fa-caret-right txt-secondary" width="10%"></td>
                <td width="80%">Global profit</td>
                <td width="10%">{{profYeste?.globalProfit | currency}}</td>
              </tr>
              <tr>
                <td class="fa fa-caret-right txt-secondary" width="10%"></td>
                <td width="80%">Global Clicks</td>
                <td width="10%">{{profYeste?.globalClicks}}</td>
              </tr>
              <tr>
                <td class="fa fa-caret-right txt-secondary" width="10%"></td>
                <td width="80%">Global Conversions</td>
                <td width="10%">{{profYeste?.globalConversions}}</td>
              </tr>
            </table>
          </div>
        </div>
    </div>
    <div class="col-md-3 col-6">
      <div class="card">
          <div class="card-header bg-primary text-center">
              <h5>This month</h5>
          </div>
          <div class="card-body bg-primary">
            <table style="width:100%" >
              <tr>
                <td class="fa fa-caret-right txt-secondary" width="10%"></td>
                <td width="80%">Global revenue</td>
                <td width="10%">{{profMonth?.globalRevenue | currency}}</td>
              </tr>
              <tr>
                <td class="fa fa-caret-right txt-secondary" width="10%"></td>
                <td width="80%">Global profit</td>
                <td width="10%">{{profMonth?.globalProfit | currency}}</td>
              </tr>
              <tr>
                <td class="fa fa-caret-right txt-secondary" width="10%"></td>
                <td width="80%">Global Clicks</td>
                <td width="10%">{{profMonth?.globalClicks}}</td>
              </tr>
              <tr>
                <td class="fa fa-caret-right txt-secondary" width="10%"></td>
                <td width="80%">Global Conversions</td>
                <td width="10%">{{profMonth?.globalConversions}}</td>
              </tr>
            </table>
          </div>
      </div>
    </div>
    <div class="col-md-3 col-6">
      <div class="card">
          <div class="card-header bg-primary text-center">
              <h5>Best Publishers</h5>
          </div>
          <div class="card-body bg-primary">
            <table style="width:100%">
              <tr *ngFor="let top of top4?.slice(0,4)">
                <td width="80%">{{top['firstName']}} {{top['lastName']}}</td>
                <td width="20%">{{top['revenue'] | currency}}</td>
              </tr>
            </table>
          </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12 col-sm-12">
      <div class="card">
        <div class="card-header">
          <h5>Profit this year</h5>
        </div>
        <div class="card-body">
          <div echarts [options]="chartOption" class="demo-chart"></div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Container-fluid Ends-->
